// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import { type Language, type Translation } from './languageModels';

// Define a service using a base URL and expected endpoints
export const languageApi = createApi({
  reducerPath: 'languageApi',
  baseQuery: baseQuery('public/translations'),
  endpoints: (builder) => {
    return {
      getLanguages: builder.query<Language[], void>({
        query: () => {
          return {
            url: 'langs',
            method: 'get',
          };
        },
      }),
      getTranslations: builder.query<Translation[], void>({
        query: () => {
          return {
            url: '',
            method: 'get',
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetLanguagesQuery, useLazyGetTranslationsQuery} = languageApi;
